import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import React, { MouseEventHandler, useCallback } from 'react'
import { connect } from 'react-redux'
import { selectBusinessTravellerCurrentApprovalRequest } from 'businessTraveller/selectors/selectBusinessTravellerCurrentApprovalRequest'

interface Props {
  /**
   * The percentage the budget is exceeded by.
   */
  underPercentage: number
  onClick: MouseEventHandler<HTMLButtonElement>
  currentApprovalRequest?: App.BusinessTraveller.ApprovalRequest
}

function PriceRowBusinessTravellerUnderBudget(props: Props) {
  const {
    underPercentage,
    onClick,
    currentApprovalRequest,
  } = props

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()

    onClick(event)
  }, [onClick])

  return <Clickable onClick={handleClick}>
    <StatusLabel variant="confirmation" endIcon={!!onClick && <LineInfoCircleIcon />}>
      {currentApprovalRequest?.approverId ? 'Within approved range' : `Under budget by ${underPercentage}%`}
    </StatusLabel>
  </Clickable>
}

const mapStateToProps = (state: App.State) => ({
  currentApprovalRequest: selectBusinessTravellerCurrentApprovalRequest(state),
})

export default connect(mapStateToProps)(PriceRowBusinessTravellerUnderBudget)
